export default __webpack_public_path__ + "static/media/ic_idea_48px.9d5f953e.svg";